import axios from "axios";

//cria a conexão com a API LOCAL
export const Api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
